import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import VideoIcon from 'public/icons/video.svg';
import DocumentIcon from 'public/icons/document.svg';
import SoundIcon from 'public/icons/sound.svg';
import styles from 'styles/components/DisplayAsset.module.scss';

const DisplayAsset = ({ asset, size, whiteIcon }) => {
  if (!asset.url) return null;

  if (asset.video) {
    return (
      <div className={clsx(styles.video, { [styles.whiteIcon]: whiteIcon })}>
        <VideoIcon style={size ? size : {}} />
      </div>
    );
  } else if (asset.content_type === 'application/pdf') {
    return (
      <div className={clsx(styles.document, { [styles.whiteIcon]: whiteIcon })}>
        <DocumentIcon style={size ? size : {}} />
      </div>
    );
  } else if (asset.content_type.includes('audio')) {
    return (
      <div className={clsx(styles.audio, { [styles.whiteIcon]: whiteIcon })}>
        <SoundIcon style={size ? size : {}} className="svg-white" />
      </div>
    );
  }

  return <Image src={asset?.url} layout="fill" alt="ToDo Asset" unoptimized />;
};

DisplayAsset.propTypes = {
  asset: PropTypes.object,
  size: PropTypes.object,
  whiteIcon: PropTypes.bool,
};

DisplayAsset.defaultProps = {
  asset: {},
  size: {},
  whiteIcon: false,
};

export default DisplayAsset;
